export default "__VITE_ASSET__DNzOwDTD__"